import { ChangeDetectionStrategy, Component, Inject, OnInit } from "@angular/core";
import { take } from "rxjs";
import colors from "wwwroot/json/colors.json";
import icons from "wwwroot/json/icons.json";
import { FeatureFlag } from "@webapp/feature-toggles/models/feature-toggles.models";
import { FeatureTogglesFacade } from "@webapp/feature-toggles/services/feature-toggles-facade.service";
import { AvatarSelector, ImgData } from "@webapp/teams/models/add-team-avatar-form.models";
import { Team } from "@webapp/teams/models/teams.models";
import { UiModalRef } from "@webapp/ui/modal/abstracts/modal-ref";
import { UI_MODAL_DATA } from "@webapp/ui/modal/modal.models";

@Component({
  selector: "add-team-avatar-form",
  templateUrl: "./add-team-avatar-form.component.html",
  styleUrls: ["./add-team-avatar-form.component.less"],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class AddTeamAvatarFormComponent implements OnInit {
  public team: Team;
  public icons: string[] = icons;
  public colors: string[] = colors.avatarSelectorColors;

  private avatarSelectorOnly: boolean = false;
  private imgData: ImgData = {
    croppedDataUrl: "",
    croppedDataForSend: "",
    pictureFile: null,
  };
  private avatarSelector: AvatarSelector = {
    isOpen: this.avatarSelectorOnly,
    showPreview: false,
    isCreateSymbol: true,
    setTabUploadPictureActive: false,
  };
  private isUploadMediaAvatarEnabled: boolean = false;

  public constructor(private modalRef: UiModalRef, private featureTogglesFacade: FeatureTogglesFacade, @Inject(UI_MODAL_DATA) private modalData?: { team: Team }) {}

  public ngOnInit(): void {
    if (this.modalData) {
      this.team = this.modalData.team;
    }

    this.featureTogglesFacade
      .isFeatureAvailable$(FeatureFlag.UploadMediaAvatar)
      .pipe(take(1))
      .subscribe((isEnabled) => {
        if (isEnabled) {
          this.isUploadMediaAvatarEnabled = isEnabled;
        }
      });
  }

  public setColor(color: string): void {
    if (this.team) {
      this.team.color = color;
    }
  }

  public setAvatar(avatar: string): void {
    if (this.team) {
      this.team.avatar = avatar;
      this.team.picture = "";
      this.imgData.pictureFile = null;
    }
  }

  public onApply(): void {
    if (this.modalRef && this.team) {
      this.modalRef.destroy({
        team: this.team,
        imgData: this.imgData,
        avatarSelector: this.avatarSelector,
        isUploadMediaAvatarEnabled: this.isUploadMediaAvatarEnabled,
      });
    }
  }

  public closeModal(): void {
    if (this.modalRef) {
      this.modalRef.destroy();
    }
  }
}
